export default __webpack_public_path__ + "static/media/before-after-loader.0fcc1681.gif";